  new Swiper(".logo-images-boxs", {
   slidesPerView: 5,
   spaceBetween: 30,
   loop: true,
   autoplay: {
    delay: 1500, 
    disableOnInteraction: false
   },
  speed: 1000,
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    580: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 20
    }
  }
});